/**
 * Core-100 R5 — job → technician assignments in the manual split modal.
 *
 * On OPEN every job starts with the ticket's current technician. While the modal stays open the advisor's choice is
 * kept for every job that is still on the ticket; only a job that was not there before gets the default. Re-rendering
 * the caller (which passes a fresh `ticketJobs` array each render) must never discard a choice.
 */
export interface JobAssignment { jobId: string; techId: string }

export function reconcileJobAssignments(
  prev: readonly JobAssignment[],
  jobIds: readonly string[],
  currentTechId: string | null,
  opening: boolean,
): JobAssignment[] {
  const kept = opening ? new Map<string, string>() : new Map(prev.map((a) => [a.jobId, a.techId] as const));
  return jobIds.map((jobId) => ({ jobId, techId: kept.get(jobId) ?? (currentTechId || '') }));
}
